import React, { useState } from "react";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import cx from "classnames";
import TabTopSold from "./tabTopSold";
import TabNew from "./tabNew";

const SpyAdvancedProductsLeaderBoard = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [searchParams] = useSearchParams();
    const defaultTab = searchParams.get('type');
    const [tab, setTab] = useState(defaultTab || "top-sold");

    const handleChangeTab = (data) => {
        navigate(location.pathname, { replace: true });
        setTab(data);
    };

    const drawTab = () => {
        if (tab === "top-sold") return <TabTopSold key={"top-sold"} typeTab="top-sold" />;
        if (tab === "hot-sell") return <TabTopSold key={"hot-sell"} typeTab="hot-sell" />;
        if (tab === "news-burst") return <TabNew />
    };

    return (
        <>
            <div className="card-body pt-0 pb-0 mb-8">
                <ul className="nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bold">
                    <li className="nav-item mt-2">
                        <span
                            onClick={() => handleChangeTab("top-sold")}
                            className={cx("nav-link text-active-primary ms-0 me-10 py-5 al-cursor-pointer", {
                                active: tab === "top-sold",
                            })}
                        >
                            Top Selling
                        </span>
                    </li>
                    <li className="nav-item mt-2">
                        <span
                            onClick={() => handleChangeTab("hot-sell")}
                            className={cx("nav-link text-active-primary ms-0 me-10 py-5 al-cursor-pointer", {
                                active: tab === "hot-sell",
                            })}
                        >
                            Hot Promoted
                        </span>
                    </li>
                    <li className="nav-item mt-2">
                        <span
                            onClick={() => handleChangeTab("news-burst")}
                            className={cx("nav-link text-active-primary ms-0 me-10 py-5 al-cursor-pointer", {
                                active: tab === "news-burst",
                            })}
                        >
                            New Product
                        </span>
                    </li>
                </ul>
            </div>
            {drawTab()}
        </>
    );
};

export default SpyAdvancedProductsLeaderBoard;
